import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorBoundary from "./components/error-boundary/error-boundary";

// Main pages
const Home = lazy(() => import("./pages/home/home"));
const Service = lazy(() => import("./pages/service/service"));
const AboutUs = lazy(() => import("./pages/about-us/about-us"));
const Career = lazy(() => import("./pages/career/career"));
const Project = lazy(() => import("./pages/project/project"));
const FormBuild = lazy(() => import("./pages/form-build/form-build"));
const NotFound = lazy(() => import("./pages/not-found/not-found"));

// Work pages
const Astra = lazy(() => import("./pages/work/astra/astra"));
const DiaryBunda = lazy(() => import("./pages/work/diary-bunda/diary-bunda"));
const Simanis = lazy(() => import("./pages/work/simanis/simanis"));
const Mokotoy = lazy(() => import("./pages/work/mokotoy/mokotoy"));
const Orari = lazy(() => import("./pages/work/orari/orari"));
const Wilopo = lazy(() => import("./pages/work/wilopo/wilopo"));
const Restaurant = lazy(() => import("./pages/work/restaurant/restaurant"));
const Beauty = lazy(() => import("./pages/work/beauty/beauty"));
const VPN = lazy(() => import("./pages/work/vpn/vpn"));
const HadistApp = lazy(() => import("./pages/work/hadist-app/hadist-app"));
const PosSystem = lazy(() => import("./pages/work/pos-system/pos-system"));
const Takjil = lazy(() => import("./pages/work/takjil/takjil"));
const Muxe = lazy(() => import("./pages/work/muxe/muxe"));

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Suspense fallback={
          <div className="min-h-screen flex items-center justify-center">
            <div className="w-10 h-10 border-4 border-[#47E0E2] border-t-transparent rounded-full animate-spin" />
          </div>
        }>
          <Routes>
            {/* Main pages */}
            <Route path="/" element={<Home />} />
            <Route path="/service" element={<Service />} />
            <Route path="/project" element={<Project />} />
            <Route path="/career" element={<Career />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/form-build" element={<FormBuild />} />

            {/* Work pages */}
            <Route path="/work/13-muxe" element={<Muxe />} />
            <Route path="/work/12-takjil" element={<Takjil />} />
            <Route path="/work/11-vpn" element={<VPN />} />
            <Route path="/work/10-hadist-app" element={<HadistApp />} />
            <Route path="/work/9-pos-system" element={<PosSystem />} />
            <Route path="/work/8-mokotoy" element={<Mokotoy />} />
            <Route path="/work/7-beauty" element={<Beauty />} />
            <Route path="/work/6-restaurant" element={<Restaurant />} />
            <Route path="/work/5-orari" element={<Orari />} />
            <Route path="/work/4-simanis" element={<Simanis />} />
            <Route path="/work/3-wilopo" element={<Wilopo />} />
            <Route path="/work/2-diary-bunda" element={<DiaryBunda />} />
            <Route path="/work/1-astra" element={<Astra />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
